module.exports = "<product-filter-form ng-if=\"$ctrl.isTablet || $ctrl.isDesktop\"> </product-filter-form> <spinner large-size ng-if=!$ctrl.relatedList></spinner> <section> <wrapper ng-if=$ctrl.relatedList> <breadcrumb-navigation breadcrumbs=$ctrl.breadcrumbs on-breadcrumb-click=$ctrl.onBreadcrumbClick> </breadcrumb-navigation> <item-list> <item ng-repeat=\"related in $ctrl.relatedList\" ng-click=$ctrl.goTo(related) id=\"$ctrl.isRelatedCommunicationTools ? null : related.code\" name=related.name image=related.image.url> </item> </item-list> </wrapper> </section> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/product/product-related/product-related.template.html
// module id = 553
// module chunks = 0